// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H22V22L2 22V2ZM6.5 11V13L17.5 13V11L6.5 11Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-minus-rectangle-filled')
export default class MinusRectangleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'minus-rectangle-filled',
    }
  }
}
